import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'
import _imports_2 from '@/app/ui/assets/svg/plus.svg'
import _imports_3 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-d4223ca2")

_pushScopeId("data-v-d4223ca2")
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2"
}
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  class: "w-4",
  alt: "chevron"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  class: "w-4",
  alt: "chevron"
}
const _hoisted_5 = {
  key: 0,
  class: "w-full bg-white absolute border border-t-0 border-gray-lp-400 rounded-b-md z-50"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "px-4 mb-2" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_7 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_8 = {
  key: 0,
  class: "px-4 py-3 border-t cursor-default"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "gap-x-2 justify-center items-center flex" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: "plus"
  }),
  /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString("Tambah Nilai"))
], -1)
const _hoisted_10 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_11 = {
  src: _imports_3,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["inline-block relative bottom-0 left-0 text-12px xxl:text-14px", 
        ` ${_ctx.customClass || 'mr-2'} ${
          !_ctx.isDisabled ? 'cursor-pointer' : 'cursor-not-allowed'
        }`
      ],
      onClick: _cache[6] || (_cache[6] = () => (_ctx.isSelectOpen ? _ctx.closeSelect() : _ctx.openSelect()))
    }, [
      (_ctx.isFirstInput)
        ? (_openBlock(), _createBlock("input", {
            key: 0,
            ref: "firstPseudoInput",
            class: "absolute pointer-events-none",
            style: {"opacity":"0"},
            disabled: _ctx.isDisabled
          }, null, 8, ["disabled"]))
        : _createCommentVNode("", true),
      _createVNode("input", {
        ref: "pseudoInput",
        class: "absolute pointer-events-none",
        style: {"opacity":"0"},
        disabled: _ctx.isDisabled,
        onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openSelect && _ctx.openSelect(...args))),
        onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCloseSelect && _ctx.onCloseSelect(...args))),
        onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args)))
      }, null, 40, ["disabled"]),
      _withDirectives(_createVNode("div", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openMenu && _ctx.openMenu(...args))),
        class: 
          `${
            _ctx.isDisabled && _ctx.disabledBackground ? 'bg-gray-lp-1500' : 'bg-white'
          } ${
            _ctx.isOpenMenu && !_ctx.isDisabled
              ? 'border-l border-t border-r rounded-t-md'
              : 'border rounded-md'
          } ${
            _ctx.isError ? 'border-red-lp-100' : 'border-gray-lp-400'
          } text-black-lp-300 px-3 py-2.5 pr-8 ${
            _ctx.textBold ? 'font-bold' : 'font-normal'
          }`
        
      }, [
        _createVNode("span", {
          class: [(_ctx.isDisabled || !_ctx.value) && !_ctx.isDefaultBlack && 'opacity-50', "leading-tight"]
        }, _toDisplayString(_ctx.ellipsisValue(
              _ctx.$t(
                _ctx.isValue(_ctx.dataOptionsList, _ctx.value) ||
                  (_ctx.dataOptionsList?.length ? _ctx.dataOptionsList[0]?.name : "Semua")
              )
            )), 3),
        (!_ctx.isDisabled)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              (_ctx.isOpenMenu)
                ? (_openBlock(), _createBlock("img", _hoisted_3))
                : (_openBlock(), _createBlock("img", _hoisted_4))
            ]))
          : _createCommentVNode("", true)
      ], 2), [
        [_directive_click_outside, () => _ctx.onCloseAnywhere()]
      ]),
      _createVNode(_Transition, { name: "select" }, {
        default: _withId(() => [
          (_ctx.isOpenMenu && !_ctx.isDisabled)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("div", {
                  class: "select overflow-auto px-3",
                  style: `max-height: ${_ctx.heightOptions}`
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataOptionsList, (item, index) => {
                    return (_openBlock(), _createBlock(_Fragment, {
                      key: item.value
                    }, [
                      (_ctx.isShowDefault ? true : item.value)
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: 
                  `cursor-pointer hover:text-red-lp-100 z-50 whitespace-nowrap ${index ===
                    _ctx.dataOptionsList.length - 1 && 'pb-2'} ${
                    item.name === _ctx.value ||
                    item.value === _ctx.value ||
                    (!_ctx.value && item.name?.toLowerCase().includes('semua'))
                      ? 'text-red-lp-100'
                      : 'text-black-lp-200'
                  }`
                
                          }, [
                            (
                    item.isDeleteable &&
                      index === _ctx.dataOptionsList.length - 1 &&
                      _ctx.isAddableListNumber
                  )
                              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                                  _createVNode("div", {
                                    onMousedown: ($event: any) => (_ctx.onChoose(item, index)),
                                    class: "py-1 w-full"
                                  }, _toDisplayString(_ctx.$t(item.name)), 41, ["onMousedown"]),
                                  _createVNode("div", {
                                    onClick: ($event: any) => (_ctx.deleteItemFromList(index))
                                  }, [
                                    _createVNode("button", null, [
                                      _createVNode(_component_Icons, {
                                        name: "delete",
                                        class: "cursor-pointer h-6 text-red-lp-200"
                                      })
                                    ])
                                  ], 8, ["onClick"])
                                ]))
                              : (_openBlock(), _createBlock("div", {
                                  key: 1,
                                  onMousedown: ($event: any) => (_ctx.onChoose(item, index)),
                                  class: "py-1"
                                }, _toDisplayString(_ctx.$t(item.name)), 41, ["onMousedown"]))
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ], 4),
                (_ctx.isAddableListNumber)
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      _createVNode("div", null, [
                        _createVNode("button", {
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addListIncreament && _ctx.addListIncreament(...args))),
                          style: {"border-color":"#d4d5d8"},
                          class: "border rounded-lg py-2 px-3 text-black-lp-300 cursor-pointer focus:outline-none"
                        }, [
                          _hoisted_9
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_10, [
      _withDirectives(_createVNode("img", _hoisted_11, null, 512), [
        [_vShow, _ctx.errorCaption]
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.errorCaption), 1)
    ], 512), [
      [_vShow, _ctx.isError]
    ])
  ]))
})